import { MontoCRC, MontoUSD } from '@/components/dominio';
import { cn } from '@/lib/utils';

interface Props {
  totales: { currencyCode: string; total: number; totalLCY: number }[];
  /** Saldo vs. lo asignado en las cuentas usadas por la propuesta (DL/colones). */
  resumenCuentas?: { totalSaldo: number; totalAsignadoLCY: number; tieneCuentas: boolean };
}

function formatearMonto(monto: number, currencyCode: string) {
  return currencyCode === 'USD' ? (
    <MontoUSD monto={monto} className="font-semibold" />
  ) : (
    <MontoCRC monto={monto} className="font-semibold" />
  );
}

/** Barra de totales anclada arriba (sticky) para que el total a pagar quede siempre visible al revisar la lista de proveedores. */
export function TotalesPropuestaBar({ totales, resumenCuentas }: Props) {
  if (totales.length === 0) return null;

  const pagosDL = totales.reduce((acc, t) => acc + t.totalLCY, 0);
  // Mismo cálculo que la columna "Diferencia" de Disponibilidad de cuentas, consolidado en DL.
  const saldo = (resumenCuentas?.totalSaldo ?? 0) - (resumenCuentas?.totalAsignadoLCY ?? 0);

  return (
    <div className="sticky top-14 z-30 flex flex-wrap items-center gap-x-6 gap-y-1.5 rounded-md border border-border bg-background/95 px-4 py-2.5 shadow-sm backdrop-blur">
      {totales.map((t) => (
        <span key={t.currencyCode} className="text-sm">
          Pagos {t.currencyCode}: {formatearMonto(t.total, t.currencyCode)}
        </span>
      ))}
      <span className="border-l border-border pl-6 text-sm text-adelante-primary-dark">
        Pagos DL: <MontoCRC monto={pagosDL} className="text-base font-bold" />
      </span>
      {resumenCuentas?.tieneCuentas && (
        <span className="border-l border-border pl-6 text-xs">
          CUENTAS DL: <MontoCRC monto={resumenCuentas.totalSaldo} />
          <span className="mx-2 text-muted-foreground">SALDO:</span>
          <MontoCRC monto={saldo} className={cn(saldo < 0 && 'font-semibold text-destructive')} />
        </span>
      )}
    </div>
  );
}
